import React from "react";
import { chart_legend_position } from "../../../../utils/constants";
import Plot from "../../../../utils/customPlotly";
import { isMobile } from "../../../../utils/deviceInfo";

const LinearNumericBarGraph = ({
  xScales,
  yScales,
  totalSumOfNumResponses,
}) => {
  // Data for the bar graph

  console.log({ xScales, yScales });

  const xValues = yScales;
  const yValues = xScales; // The raw data
  console.log({ x: xValues, y: yValues, totalSumOfNumResponses });

  const percentages = xValues.map(
    (y) => Math.round((y / totalSumOfNumResponses) * 100).toFixed(2) + "%"
  ); // Convert raw data to percentages

  const yLabels = xValues.map((y, i) =>
    y > 0 ? `<b>${parseInt(percentages[i])}%</b> (${y})` : ""
  ); // Combine percentage and raw value

  const colors = [
    "#4E79A7", // Vivid Red-Orange
    "#F28E2B", // Vivid Green
    "#E15759", // Vivid Blue
    "#76B7B2", // Vivid Pink
    "#59A14F", // Aqua
    "#EDC948", // Dark Orange
    "#B07AA1", // Vivid Violet
    "#FF9DA7", // Bright Mint
    "#9C755F", // Vivid Rose
    "#BAB0AC", // Bright Yellow
  ];

  const chartData = yValues.map((y, ind) => {

    return {
      x: [xValues[ind]],
      y: [""],
      legendrank: ind+1,
      name:
        ind == 0
          ? `${y} (Lowest)`
          : ind == yValues.length - 1
          ? `${y} (Highest)`
          : y,
      orientation: "h",
      type: "bar",
      marker: {
        color: colors[ind] || "red",
        width: 1,
      },
      text: yLabels[ind],
      textposition: "inside",
      hoverinfo: "text", // Custom hover information
    };
  });

  console.log(chartData)

  return (
    <div>
      <Plot
        data={chartData}
        layout={{
          barmode: "stack",

          xaxis: {
            showline: false, // Hide X-axis line
            showgrid: false, // Hide X-axis grid lines
            zeroline: false, // Hide X-axis base line
            showticklabels: false, // Hide X-axis labels
          },
          yaxis: {
            dtick: 1,
            showticklabels: true, // Hide Y-axis labels
          },
          margin: {
            t: isMobile?40: 0, // Adjust top margin
          },
          plot_bgcolor: "rgba(0,0,0,0)", // Make background transparent
          paper_bgcolor: "rgba(0,0,0,0)", // Make paper background transparent
          bargap: 0.5, // Adjust gap between bars
          legend: {
            traceorder:"normal",
            bgcolor: "white",
            xref: "container",
            yref: "container",
            yanchor: "top",
            xanchor: "left",
            // y:-0.4, // good for 3 kpis or greater
            // y:-0.3,
            y: chart_legend_position(chartData.length),
            x: 0,
            orientation: "h",
          },
        }}
        style={{ height: "190px", width: isMobile ? "320px": "600px" }}
      />
    </div>
  );
};

export default LinearNumericBarGraph;
